<template>
  <div>
    <highcharts :options="highChartOptions"></highcharts>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  props: {
    productID: {},
    selectedDateRange: String,
  },
  data() {
    return {
      highChartOptions: {
        credits: {
          enabled: false
        },
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        // lang: {
        //   noData: 'WHAT IS LOVE>',
        // },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              formatter: function() {
                return window.accounting.formatMoney(this.y)
              }
            }
          }
        },
        tooltip: {
          enabled: false,
        },
        series: [],
      },
    }
  },
  watch: {
    selectedDateRange() {
      this.get()
    }
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
    })
  },
  mounted() {
    this.get()
  },
  methods: {
    get() {
      let dateRange = this.$getDateRangeByIdentifier(this.selectedDateRange)
      axios.post('reports/product/totals', {
        from: dateRange.from.format(this.config.dateTimeFormats.api),
        to: dateRange.to.format(this.config.dateTimeFormats.api),
        productID: this.productID,
      })
        .then((response) => {
          const totals = response.data
          let data = []
          for (let i in totals) {
            data.push({
              y: parseFloat(totals[i].total),
              color: totals[i].type === 'sales' ? '#1abc9c' : '#f1556c'
            })
          }

          this.highChartOptions.xAxis.categories = totals.map(e => e.type)
          this.highChartOptions.series = [
            {
              name: 'Total',
              showInLegend: false,
              data,
            },
          ]
        })
    }
  }
}
</script>

